@if (itemsType.length > 0) {
  <mat-radio-group #mrb1 [(ngModel)]="value" [disabled]="checkForDisabled(getAttribute('name'))"
    [ngClass]="{ 'is-invalid': form?.submitted && getName() != null }">
    @for (item of parsedAnswers; track item) {
      <mat-radio-button [disableRipple]="true" [value]="item">{{item.Name}}</mat-radio-button>
    }
  </mat-radio-group>
}

@if (itemsType.length == 0) {
  <mat-radio-group #mrb2 [(ngModel)]="value" [disabled]="checkForDisabled(getAttribute('name'))"
    [ngClass]="{ 'is-invalid': form?.submitted && getName() != null }">
    @for (item of parsedAnswers; track item) {
      <mat-radio-button [disableRipple]="true" [value]="item.Value">{{item.Name}}</mat-radio-button>
    }
  </mat-radio-group>
}
